import React, { useContext } from "react";
import { StatusContext } from "../contexts/Status.context";
import { UserInfoContext } from "../contexts/UserInfo.context";
import Finish from "./App/Finish";
import Mechanics1 from "./App/Mechanics1";
import TrainingMenu from "./App/TrainingMenu";
import Auth from "./Auth";
import MainMenu from "./App/MainMenu";
import { shuffleNumArray } from "../utils";
import Mechanics2 from "./App/Mechanics2";
import Train from "./App/Train";
import QuickGuide from "./App/QuickGuide";
import FinishSection from "./App/FinishSection";
import FreeTest from "./App/FreeTest";

const Dashboard: React.FC = () => {
  const { isLogged } = useContext(UserInfoContext);
  const { pageStatus, problemNumber, mechanics, engine, setProblems } =
    useContext(StatusContext);

  const renderPageWithStatus = () => {
    if (!isLogged) {
      switch (pageStatus) {
        case "Welcome":
          return (
            <div className="text-center text-lg mt-16">Welcome to METV</div>
          );
        case "Login":
          return (
            <div className="text-center text-lg mt-16">
              Redirecting to login page...
            </div>
          );
        default:
          break;
      }
    } else {
      if (engine === "guide") {
        return <QuickGuide />;
      }
      if (engine === "menu") {
        if (pageStatus === "Menu") return <MainMenu />;
        if (pageStatus === "Training menu") return <TrainingMenu />;
      }
      if (engine === "train") {
        return <Train />;
      }
      if (engine === "practice" || engine === "test") {
        if (mechanics === 1) {
          if (problemNumber > 20) {
            return <FinishSection />;
          } else {
            return <Mechanics1 />;
          }
        } else if (mechanics === 2) {
          if (problemNumber > 20) {
            return <FinishSection />;
          } else {
            return <Mechanics2 />;
          }
        }
      }
      if (engine === "test" && pageStatus === "Free Test") {
        return <FreeTest />;
      }
    }
  };

  return <div className="text-white w-full">{renderPageWithStatus()}</div>;
};

export default Dashboard;
